// src/Home.js
import React, { useState } from "react";

import mindy from "./assets/mindy.png";
import mindyLight from "./assets/mindylight.png";
import mindyGreeting from "./assets/mindygreeting.png"; // bubble-only image

export default function Home() {
  const [hover, setHover] = useState(false);
  const [greet, setGreet] = useState(false);

  // when greeting is open, keep the base as normal (not light)
  const baseSrc = greet ? mindy : (hover ? mindyLight : mindy);

  return (
    <div className="home-container">
      <div className="content">
        {/* Mindy with bubble overlay pinned to the right */}
        <button
          type="button"
          className={`mindy-wrap ${hover && !greet ? "is-hover" : ""} ${greet ? "is-greet" : ""}`}
          onClick={() => setGreet(g => !g)}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          onTouchStart={() => setHover(true)}
          onTouchEnd={() => setHover(false)}
          aria-pressed={greet}
          aria-label={greet ? "Hide greeting" : "Show greeting"}
        >
          {/* Spacer locks the layout to the base Mindy size */}
          <img src={mindy} alt="" className="mindy-spacer" aria-hidden="true" />

          {/* Base Mindy image (right-anchored) */}
          <img src={baseSrc} alt="Mindy" className="mindy-base" />

          {/* Bubble overlay (right-anchored, extends left). Stays above base. */}
          <img
            src={mindyGreeting}
            alt=""
            className="mindy-bubble"
            aria-hidden="true"
          />
        </button>

        {/* Text content */}
        <div className="text-content">
          <h1 className="welcome-text">Welcome to Minminmachine!</h1>
          <p>
            Yoohoo! I’m Mindy, a recent UVA grad in computer science and painting. My love
            for funky designs and playful creativity led me to start Minminmachine, where I
            explore the whimsical and unexpected. When I’m not working on something goofy,
            I’m usually hanging out with my two cats, Ekko and Sesame. Thanks for stopping by!
          </p>
        </div>
      </div>
    </div>
  );
}
